import {
	SAVE_CUST_AGGR_STATS_GRAPH,
	CUST_AGGR_STATS_GRAPH_API_LOADING,
	GRAPH_BY_FILTER,
	GRAPH_BY_FILTER_CUSTOM,
} from '../../constants/graphConstants/customerAggrStatsGraphConstants';

/**
 * Reducer function for managing hiSenese graph .
 *
 * @param {object} state - Current state of the user login.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const customerAggrStatsReducer = (
	state = {
		loading: false,
		filterBy: '4h',
		stats: {},
		customFilterDate: null,
		customerAggrStatsError : null
	},
	action
) => {
	switch (action.type) {
		case SAVE_CUST_AGGR_STATS_GRAPH:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case CUST_AGGR_STATS_GRAPH_API_LOADING:
			return {
				...state,
				stats: {},
				customerAggrStatsError : null,
				loading: action.payload,
			};
		case GRAPH_BY_FILTER:
			return {
				...state,
				filterBy: action.payload,
			};
		case GRAPH_BY_FILTER_CUSTOM:
			return {
				...state,
				customFilterDate: action.payload,
			};
		default:
			return state;
	}
};
